import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import type { EmptyScreensBaseArgs } from 'webapp/components/empty-screens/base';
import EmptyScreensBaseComponent from 'webapp/components/empty-screens/base';

export default class EmptyScreensBoardAccountTemplatesComponent extends EmptyScreensBaseComponent<EmptyScreensBaseArgs> {
	@service('account') declare accountService: Service.Account;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;

	trackingOrigin = 'databoard_account_templates';

	constructor(owner: Owner, args: EmptyScreensBaseArgs) {
		super(owner, args);

		this.titleText = 'Create standardized, reusable templates';
		this.descText = 'Set up reporting faster and keep it consistent across accounts.';
		this.topImageLightUrl = '/images/placeholders/board-account-templates.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/board-account-templates.svg';

		this.trialFeatures = [BillingFeature.ACCOUNT_TEMPLATES];
		this.readMoreUrl = 'https://help.databox.com/create-a-template';

		this.imageLightUrl = '/images/placeholders/placeholder-board-account-templates.png';

		this.mainActions = [
			{
				action: this.openTemplateEditPopup,
				icon: 'Plus',
				text: 'New template',
				isForCreating: true,
			},
		];

		this.arrowText = 'Click here to save your first account template';
	}

	override get isNewSectionShown() {
		return super.isNewSectionShown && !!this.mmBoardsService.normalBoardModels.length;
	}

	override get showTemplatesPlaceholder() {
		return this.accountService.showPublicTemplates;
	}

	@action
	openTemplateEditPopup(): void {
		this.mmBoardsService.checkToOpenAccountTemplateEditPopup();
	}
}
